import { render, staticRenderFns } from "./BagsTemplate.vue?vue&type=template&id=2b132083"
import script from "./BagsTemplate.vue?vue&type=script&lang=js"
export * from "./BagsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports